/**
 * Import Lib & assets
 */

import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";
import { ContentContext } from "context/contentContext";

/**
 * import components
 */

/**
 * styled components
 */

const Checkbox = styled.div`
  ${t.mixins.flex()}
`;
const Container = styled.div`
  ${t.mixins.flex()}
  padding: 0 30px;

  ${t.mixins.sm(`
    align-self: stretch;
    padding: 0 25px;

    &:first-of-type {
      padding: 0 25px 0 0;
    }

    &:last-of-type {
      padding: 0 0 0 25px;
    }
  `)}
`;
const Input = styled.div`
  ${t.mixins.flex({ direction: "column" })}
  ${t.mixins.sm(`
    ${t.mixins.flex({ direction: "column", justify: "space-between" })}
    height: 100%;
  `)}
`;
const Image = styled.img`
  margin-bottom: 31px;
  user-drag: none;
  height: 140px;

  ${t.mixins.sm(`
    max-height: 100px;
    max-width: 100px;
  `)}
`;
const Title = styled.p`
  ${t.mixins.rem(18, 19)};
  font-family: ${t.font.primary};
  font-weight: ${t.font.regular};
  text-align: center;

  ${t.mixins.sm(`
    ${t.mixins.rem(13, 17)}
  `)}
`;
const Description = styled.p`
  max-width: 187px;
  ${t.mixins.rem(14, 19)};
  font-family: ${t.font.primary};
  font-weight: ${t.font.regular};
  text-align: center;
  margin-bottom: 18px;

  ${t.mixins.sm(`
    ${t.mixins.rem(14, 14)}
  `)}
`;
const Box = styled.div`
  ${t.mixins.flex()}
  height: 21px;
  width: 21px;
  border-radius: 5px;
  border: solid 1px ${t.color.darkGrey};
  cursor: pointer;

  ${({ selected }) =>
    selected &&
    `
    background-color: ${t.color.secondary}
    border: none;

  `}

  ${t.mixins.sm(`
    height: 16px;
    width: 16px;
  `)}
`;
const Separator = styled.p`
  ${t.mixins.rem(13, 19)}
  font-family: ${t.font.primary};
  font-weight: ${t.font.normal};
  text-align: center;
  margin-bottom: 70px;

  ${t.mixins.sm(`
    ${t.mixins.rem(13, 11)}
    min-width: 40px;
  `)}
`;
const Cross = styled.img.attrs({ src: t.image.cross })`
  width: 15px;
  height: 13px;
  user-select: none;
  user-drag: none;

  ${t.mixins.sm(`
    height: 10px;
    width: 9px;
  `)}
`;

/**
 * checkbox component is..
 */

const Form__checkbox = ({ answers, updateValue, filled = undefined }) => {
  const [selected, setSelected] = useState(filled);
  const isSelected = id => {
    if (selected) return selected.includes(id);
  };
  const { c } = useContext(ContentContext);
  const addAnswer = id => {
    if (!selected) {
      setSelected([id]);
    } else if (isSelected(id)) {
      setSelected(selected.filter(key => key !== id));
    } else {
      setSelected([...selected, id]);
    }
  };
  useEffect(() => {
    if (selected) {
      updateValue(selected);
    }
  }, [selected]);
  return (
    <Checkbox>
      {answers.map((answer, index) => {
        const { title, id, img, description } = answer;
        const selectedAnswer = isSelected(id);
        return (
          <>
            <Container
              key={id}
              onClick={() => {
                addAnswer(id);
              }}
            >
              <Input>
                <Image src={t.image[img]} />
                <Title>{title}</Title>
                <Description>{description}</Description>
                <Box selected={selectedAnswer}>{selectedAnswer && <Cross />}</Box>
              </Input>
            </Container>
            {index !== answers.length - 1 && <Separator>{c("home.form.possibilities")}</Separator>}
          </>
        );
      })}
    </Checkbox>
  );
};

export default Form__checkbox;

Form__checkbox.propTypes = {
  /**
      Function to trigger when new radio selected
      */
  updateValue: PropTypes.func.isRequired,
};

/*
    import Form__checkbox from 'components/form/checkbox/form__checkbox'
    <Form__checkbox />
  */
